import { useState } from 'react';
import type { PressEvent } from 'react-aria';
import type { ButtonProps } from '@launchpad-ui/components';
import { Button } from '@launchpad-ui/components';

import { trackRequestNewSeats } from '#utils/accounts/accountAnalyticEvents';

import { RequestSeatsModal } from './RequestSeatsModal';

type AnalyticsProps = {
  componentName: string;
  type?: 'link' | 'button';
};

export type RequestMembersControlProps = {
  analyticsProps: AnalyticsProps;
  buttonProps?: ButtonProps;
  cta?: string;
};

export const RequestSeatsControl = ({
  cta = 'Request seats',
  buttonProps,
  analyticsProps,
}: RequestMembersControlProps) => {
  const [showModal, setShowModal] = useState(false);
  const { componentName, type = 'button' } = analyticsProps;

  const openModal = (e: PressEvent) => {
    trackRequestNewSeats({
      url: window.location.href,
      component: componentName,
      type,
    });
    setShowModal(true);
    buttonProps?.onPress?.(e);
  };

  const renderModal = () => {
    if (showModal) {
      return <RequestSeatsModal onCancel={() => setShowModal(false)} />;
    }
  };

  return (
    <>
      <Button variant="default" {...buttonProps} onPress={openModal}>
        {cta}
      </Button>
      {renderModal()}
    </>
  );
};
